import { c as _c } from "react/compiler-runtime";
import { App, ConfigProvider } from 'antd';
import enGB from 'antd/locale/en_GB';
import { NotificationProvider } from '../components/Notification/NotificationProvider';
import { lightTheme } from '../themes';
export const AntdThemeProvider = t0 => {
  const $ = _c(17);
  const {
    children,
    isClientApp: t1
  } = t0;
  const isClientApp = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      colorPrimary: lightTheme.colors.typePrimary,
      colorSuccess: lightTheme.colors.semanticPositive,
      colorError: lightTheme.colors.semanticNegative,
      colorBgContainer: lightTheme.colors.bgSecondary,
      colorBgLayout: "transparent",
      colorText: lightTheme.colors.typePrimary,
      colorTextSecondary: lightTheme.colors.typeTertiary,
      fontFamily: "Gilroy, Arial, Helvetica, sans-serif",
      colorLink: lightTheme.colors.actionLink,
      colorLinkHover: lightTheme.colors.actionLinkHover,
      controlOutline: "1px solid red",
      colorBgContainerDisabled: lightTheme.colors.bgPrimary
    };
    t3 = {
      primaryShadow: "none",
      colorPrimaryHover: lightTheme.colors.typePrimary,
      colorTextBase: lightTheme.colors.typePrimary,
      colorTextLightSolid: lightTheme.colors.typePrimary
    };
    t4 = {
      colorPrimaryHover: lightTheme.colors.actionPrimary,
      colorBgContainerDisabled: lightTheme.colors.architecture3
    };
    t5 = {
      paddingBlock: 0,
      padding: 0,
      paddingContentHorizontal: 0,
      paddingContentHorizontalLG: 0,
      paddingContentHorizontalSM: 0,
      paddingContentVertical: 0,
      paddingContentVerticalLG: 0,
      paddingContentVerticalSM: 0,
      paddingLG: 0,
      paddingMD: 0,
      paddingSM: 0,
      paddingXL: 0,
      paddingXS: 0,
      paddingXXS: 0,
      controlPaddingHorizontal: 0,
      controlPaddingHorizontalSM: 0
    };
    t6 = {
      filterDropdownBg: "transparent",
      headerBorderRadius: 4
    };
    t7 = {
      siderBg: lightTheme.colors.bgSecondary,
      lightSiderBg: lightTheme.colors.bgSecondary
    };
    t8 = {
      colorBorder: lightTheme.colors.architecture3
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
  }
  let t9;
  if ($[7] !== isClientApp) {
    t9 = {
      Button: t3,
      Checkbox: t4,
      Dropdown: t5,
      Table: t6,
      Layout: t7,
      Select: t8,
      ...(isClientApp ? {
        Menu: {
          itemBg: lightTheme.colors.bgSecondary,
          itemColor: lightTheme.colors.typePrimary,
          itemHoverBg: lightTheme.colors.actionPrimary,
          itemSelectedBg: lightTheme.colors.bgSecondary
        }
      } : {})
    };
    $[7] = isClientApp;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      key: "app"
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t9) {
    t11 = {
      token: t2,
      components: t9,
      hashed: false,
      cssVar: t10
    };
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== children) {
    t12 = <NotificationProvider><App>{children}</App></NotificationProvider>;
    $[12] = children;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11 || $[15] !== t12) {
    t13 = <ConfigProvider locale={enGB} theme={t11}>{t12}</ConfigProvider>;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  return t13;
};